import type { ApiError } from '@/lib/api/errors';

export function formSubmissionErrorMessage(error: ApiError): string {
  const data = error.data as { code?: unknown; message?: unknown } | undefined;
  const code = typeof data?.code === 'string' ? data.code : undefined;
  const message = typeof data?.message === 'string' ? data.message : undefined;

  if (code === 'FORM_ALREADY_SUBMITTED') {
    return 'This form was already submitted for this visit. Open the existing submission to edit it (if it\'s still a draft), or enable "Allow multiple submissions" in the form template.';
  }
  if (code === 'APPOINTMENT_TERMINAL') {
    return "Can't modify forms on a visit that's already completed or cancelled.";
  }
  if (code === 'FORM_SUBMISSION_FROZEN') {
    return 'This submission is locked because it was already completed. Create a new submission to record corrections.';
  }

  return message ?? error.message ?? 'Could not save the form.';
}
